import { useNavigationContainerRef } from '@react-navigation/native';
import { createContext, ReactNode, useContext } from 'react';

export type NavigationContainerRef = ReturnType<
  typeof useNavigationContainerRef
>;

export type NavigationContainerRefContextProps = {
  navigationRef: NavigationContainerRef;
};

export const NavigationContainerRefContext =
  createContext<NavigationContainerRefContextProps>(null as any);

export const NavigationContainerRefProvider = ({
  navigationRef,
  children,
}: {
  navigationRef: NavigationContainerRef;
  children?: ReactNode;
}) => {
  return (
    <NavigationContainerRefContext.Provider value={{ navigationRef }}>
      {children}
    </NavigationContainerRefContext.Provider>
  );
};

export const useNavigationRef = () =>
  useContext(NavigationContainerRefContext).navigationRef;
